(function () {
  'use strict';
  var dialog = document.getElementById('cjau-personalised-delay');
  if (!dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  var key = 'cjau-personalised-dispatch-dismissed-v1';
  var dismissed = false;
  try { dismissed = sessionStorage.getItem(key) === '1'; } catch (error) {}
  if (dismissed) return;
  var previousFocus = document.activeElement;
  function rememberDismissal() {
    try { sessionStorage.setItem(key, '1'); } catch (error) {}
    if (previousFocus && previousFocus.focus) previousFocus.focus();
  }
  dialog.addEventListener('close', rememberDismissal);
  dialog.querySelector('[data-cjau-delay-dismiss]').addEventListener('click', function () {
    if (typeof dialog.close === 'function') dialog.close();
    else { dialog.removeAttribute('open'); rememberDismissal(); }
  });
  if (typeof dialog.showModal === 'function') dialog.showModal();
  else dialog.setAttribute('open', '');
})();
